export default "__VITE_ASSET__DqSFxLXp__"